import { render, staticRenderFns } from "./CourseFolderDetails.vue?vue&type=template&id=77bd938e&scoped=true"
import script from "./CourseFolderDetails.vue?vue&type=script&lang=js"
export * from "./CourseFolderDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseFolderDetails.vue?vue&type=style&index=0&id=77bd938e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bd938e",
  null
  
)

export default component.exports